import React from "react";

const Loader = () => (
  <div className="spinner-wrapper">
    <div className="spinner"></div>
  </div>
);

export default Loader;
